import { render, staticRenderFns } from "./TheOrganizationStaffRoleList.vue?vue&type=template&id=f14c6898&"
import script from "./TheOrganizationStaffRoleList.vue?vue&type=script&lang=js&"
export * from "./TheOrganizationStaffRoleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports